import axios, { encodeData } from "../utils/axios";

export const fetchAmkaAndVerify = async (amka) => {
  const res = await axios.post("/gateway/checkAmka", encodeData(amka));
  return res;
};

export const updateAmka = async (afm, amka) => {
  const res = await axios
    .post("/amkaverification/update", encodeData(afm, amka))
    .catch((error) => {
      if (error.response) {
        console.log(error);
      }
    });
  return res.data;
};
